import type { TimeOffRequest } from "./api";
import { TIME_OFF_TYPES } from "./shared/timeOffTypes";
import { STATUS_LABEL } from "./format";

function csvEscape(value: string | number | null | undefined): string {
  let str = value === null || value === undefined ? "" : String(value);
  // Neutralize formula injection (CWE-1236): a leading =, +, -, or @ would
  // otherwise be interpreted as a formula by Excel/Sheets when this export
  // is opened, and these fields (note, deny reason) contain free text from
  // requesters/approvers, not trusted app-generated content. A leading
  // apostrophe forces those tools to treat the cell as plain text.
  if (/^[=+\-@]/.test(str)) str = `'${str}`;
  return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
}

const CSV_HEADERS = [
  "Person",
  "Email",
  "Type",
  "Start Date",
  "End Date",
  "Day Part",
  "Status",
  "Note",
  "Submitted At",
  "Decided By",
  "Decided At",
  "Needs Coordination Reason",
];

export function requestsToCsv(requests: TimeOffRequest[]): string {
  const rows = requests.map((r) => [
    r.person_name ?? "",
    r.person_email,
    TIME_OFF_TYPES[r.type].label,
    r.start_date,
    r.end_date,
    r.day_part,
    STATUS_LABEL[r.status],
    r.note ?? "",
    r.submitted_at,
    r.decided_by_email ?? "",
    r.decided_at ?? "",
    r.deny_reason ?? "",
  ]);
  return [CSV_HEADERS, ...rows].map((row) => row.map(csvEscape).join(",")).join("\r\n");
}

export function downloadCsv(filename: string, csv: string): void {
  // Leading BOM so Excel opens the UTF-8 file correctly instead of mangling
  // any accented characters in names.
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
